export const defaultClientOptions = {
  na1: {
    environment: 'hubspot',
    fallbackHosts: ['hubspot-a-fallback.ably-realtime.com', 'hubspot-b-fallback.ably-realtime.com', 'hubspot-c-fallback.ably-realtime.com', 'hubspot-d-fallback.ably-realtime.com', 'hubspot-e-fallback.ably-realtime.com']
  },
  eu1: {
    environment: 'hubspot-eu',
    fallbackHosts: ['hubspot-eu-a-fallback.ably-realtime.com', 'hubspot-eu-b-fallback.ably-realtime.com', 'hubspot-eu-c-fallback.ably-realtime.com', 'hubspot-eu-d-fallback.ably-realtime.com', 'hubspot-eu-e-fallback.ably-realtime.com']
  }
};